export const storyDefault = Object.freeze({});
